<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Edit Scheduled Activity</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5 tw-mb-3">
        <base-select
          required
          label="Trigger on"
          :options="triggerOptions"
          v-model="trigger"
          placeholder="When should this activity get created?"
          label-key="label"
          value-key="value"
        />
        <base-select
          required
          class=""
          label="Activity Type"
          :options="todoItemTypes"
          v-model="selectedItemTypeId"
          placeholder="Select activity type"
          label-key="label"
          value-key="todoItemTypeId"
        />
        <base-text-field label="Due Date" placeholder="Set the number of days after the trigger." type="number" v-model="daysAfter" min="0" max="1000" step="1" required />
        <base-textarea label="Initial Note (optional)" placeholder="Enter an initial reminder note." v-model="note" />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error class="tw-mt-3" id="add-business-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  name: "EditScheduledActivity",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
    businessPlanId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      triggerOptions: [{ label: "When plan is created", value: "plan_create" }, { label: "When plan is cancelled", value: "plan_cancel" }],
      trigger: null,
      selectedItemTypeId: null,
      daysAfter: 0,
      note: null,
      businessPlanActivityScheduleId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
      todoItemTypes: [],
    };
  },
  created() {
    this.loadTodoTypes();
  },
  computed: {
    computedSelectedType() {
      return this.todoItemTypes.find((i) => {
        return i.todoItemTypeId === this.selectedItemTypeId;
      });
    },
  },
  methods: {
    loadTodoTypes() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.businessId}/todo/types`)
        .then((res) => {
          this.todoItemTypes = res.data.sort((a, b) => {
            return a.label.localeCompare(b.label);
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reset() {
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(businessPlanActivityScheduleId, todoItemTypeId, trigger, daysAfter, note) {
      this.businessPlanActivityScheduleId = businessPlanActivityScheduleId;
      this.selectedItemTypeId = todoItemTypeId;
      this.trigger = trigger;
      this.daysAfter = daysAfter;
      this.note = note;
      this.$refs.modal.show();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/plans/${this.businessPlanId}/activity-schedule/${this.businessPlanActivityScheduleId}`, {
          todoItemTypeId: this.computedSelectedType.todoItemTypeId,
          trigger: this.trigger,
          daysAfter: this.daysAfter,
          note: this.note,
        })
        .then(() => {
          this.$emit("scheduledActivitiesUpdated", {});
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Activity Saved", message: `Your activity was saved.` });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error creating scheduled activity`;
          this.errorMessage = "Sorry, we had trouble changing this scheduled activity. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
